import type { CountryCode } from '@mote/helpers'

export type ProductTypes =
  | 'essential'
  | 'unlimited'
  | 'essential_volume'
  | 'unlimited_volume'
  | 'schools'

export type ProductCurrencies = 'aud' | 'cad' | 'eur' | 'gbp' | 'usd'

export type ProductCurrencyMap = Record<ProductCurrencies, string>

export interface Coupons {}

export interface Currency {
  currencyCode: ProductCurrencies
  hasCentiles: boolean
  longName: string
  shortName: string
  symbol: string
}

export interface ProductPlainCurrency {
  currency: ProductCurrencies
  hasCentiles: boolean
  planEnum: string
  planName: string
  priceId: string
  productEnum: ProductTypes
  productId: string
  productName: string
  rawMonthlyPrice: number
  rawPrice: number
  rawYearlyPrice: number
}

export interface ProductTier {
  from: number
  rawYearlyPrice: number
  to: number
}

export interface ProductVolumeCurrency extends ProductPlainCurrency {
  tiers: ProductTier[]
}

export type ProductCurrenciesGeneric<T> = Record<ProductCurrencies, T>

export interface ProductGeneric<T> {
  year: ProductCurrenciesGeneric<T>
}

export type ProductPlain = ProductGeneric<ProductPlainCurrency>
export type ProductVolume = ProductGeneric<ProductVolumeCurrency>

export type ProductVariant = ProductPlain | ProductVolume

export function isVolumeSku(
  product: ProductPlainCurrency | ProductVolumeCurrency
): product is ProductVolumeCurrency {
  return 'tiers' in product
}

export interface Products {
  essential: ProductPlain
  essential_volume: ProductVolume
  schools: ProductVolume
  unlimited: ProductPlain
  unlimited_volume: ProductVolume
}

export interface ProductsDTO {
  actualCountryCode: CountryCode
  coupons: Coupons
  currencies: Currency[]
  currencySymbols?: ProductCurrencyMap
  products: Products
  provider: string
  readCatalogFromCache: boolean
  recommendedCurrency: ProductCurrencies
  recommendedCurrencyLongName: string
  recommendedCurrencyShortName: string
  recommendedCurrencySymbol: string
  wroteCatalogToCache: boolean
}

export interface ProductsWithSymbols extends ProductsDTO {
  currencySymbols: ProductCurrencyMap
}
